import {Injectable} from '@angular/core';
import {catchError, finalize, map} from "rxjs/operators";
import {Observable, throwError} from "rxjs";

import {IsEmptyString, IsEmptyVar} from "../../defines/common.func";
import {SearchParam} from "../../defines/client.const";
import {PAGE, SASEUNG3_HANJA_API_URL} from "../../defines/protocol";
import {Saseung3} from "../../models/saseung3.model";
import {ApiService} from "../api/api.service";
import {ListLoader, ListLoader_NextList} from "../../interfaces/list-loader";
import {NormalizeSearchKeyword} from "../../defines/search-keyword.func";


@Injectable({
  providedIn: 'root'
})
export class Saseung3HanjaService implements ListLoader<Saseung3> {
  protected urlApi = SASEUNG3_HANJA_API_URL;

  protected totalCount: number | null = null;
  protected listSaseung: Array<Saseung3> | null = null;
  protected mapSaseung: Map<string, Saseung3> | null = null;
  protected nextUrl: string | null = null
  private load$: Observable<ListLoader_NextList<Saseung3>> | null = null;

  constructor(
    protected api: ApiService,
  ) {
  }


  /******************************************************************************
   * ListLoader<Saseung3> 구현부
   *****************************************************************************/
  public getList(): Array<Saseung3> | null {
    return this.listSaseung;
  }

  public getCurCount(): number | null {
    // @ts-ignore
    return this.listSaseung?.length ?? null;
  }

  public getTotalCount(): number | null {
    return this.totalCount;
  }

  public IsComplete(): boolean {
    // @ts-ignore
    return this.totalCount === 0 ||
      (this.listSaseung && !IsEmptyVar(this.totalCount) && this.listSaseung.length === this.totalCount);
  }

  public IsLoading(): boolean {
    return this.load$ !== null;
  }

  public getById(id: string): Saseung3 | null {
    return this.mapSaseung?.get(id) ?? null;
  }

  public ResetList(param: SearchParam | null = null): void {
    this.listSaseung = null;
    this.mapSaseung = null;
    this.totalCount = null;

    const queryParams = new URLSearchParams();

    if (param) {
      if (param.hangul) queryParams.set('hangul', param.hangul);
      if (param.hanja) queryParams.set('hanja', param.hanja);
      const keyword = NormalizeSearchKeyword(param.keyword);
      if (keyword) queryParams.set('search', keyword);
    }

    this.nextUrl = queryParams.toString()
      ? `${this.urlApi}?${queryParams.toString()}`
      : this.urlApi;
  }

  public GetNextList(): Observable<ListLoader_NextList<Saseung3>> {
    // console.log('Saseung3HanjaService::GetNextList()', this.urlApi, this.nextUrl);

    if (IsEmptyString(this.nextUrl)) {
      return throwError({error: 'No more pages in Saseung3List'});
    }

    if (this.load$) {
      return this.load$;
    }

    return this.load$ = this.api.Get(this.nextUrl!).pipe(
      catchError(err => {
        if ('status' in err && err.status === 404) {
          this.totalCount = 0;
        }
        throw err;
      }),
      finalize(() => {
        this.load$ = null;
      }),
      map((data: PAGE) => {
        // console.log('Saseung3HanjaService::GetNextList.api.Get data =', data);

        let first = false;
        if (this.totalCount === null) {
          this.totalCount = data.count;
          this.listSaseung = new Array<Saseung3>();
          this.mapSaseung = new Map<string, Saseung3>();
          first = true;
        } else if (this.totalCount !== data.count) {
          console.error('[error]' + this.urlApi, data);
        }

        const list = new Array<Saseung3>();

        data.results.forEach(value => {
          const saseung = new Saseung3(value);
          this.listSaseung?.push(saseung);
          this.mapSaseung?.set(saseung.id, saseung);
          this.mapSaseung?.set(saseung.hanja, saseung);
          list.push(saseung);
        });

        this.nextUrl = data.next;

        return {list, first};
      })
    );
  }
}
